// Because lodash is tree-shaken, doing this will not work on prod
// import { chain } from 'lodash-es';
// chain(results).groupBy('_group').mapValues((record) => ...).value();
// See https://github.com/lodash/lodash/issues/3298#issuecomment-341685354
import type { CollectionChain } from 'lodash';
import chunk from 'lodash-es/chunk';
import compact from 'lodash-es/compact';
import countBy from 'lodash-es/countBy';
import difference from 'lodash-es/difference';
import every from 'lodash-es/every';
import filter from 'lodash-es/filter';
import find from 'lodash-es/find';
import flatMap from 'lodash-es/flatMap';
import flatten from 'lodash-es/flatten';
import groupBy from 'lodash-es/groupBy';
import intersection from 'lodash-es/intersection';
import keyBy from 'lodash-es/keyBy';
import map from 'lodash-es/map';
import mapValues from 'lodash-es/mapValues';
import maxBy from 'lodash-es/maxBy';
import minBy from 'lodash-es/minBy';
import omit from 'lodash-es/omit';
import orderBy from 'lodash-es/orderBy';
import partition from 'lodash-es/partition';
import pick from 'lodash-es/pick';
import reduce from 'lodash-es/reduce';
import reverse from 'lodash-es/reverse';
import size from 'lodash-es/size';
import some from 'lodash-es/some';
import sortBy from 'lodash-es/sortBy';
import sumBy from 'lodash-es/sumBy';
import take from 'lodash-es/take';
import takeWhile from 'lodash-es/takeWhile';
import toPairs from 'lodash-es/toPairs';
import union from 'lodash-es/union';
import uniq from 'lodash-es/uniq';
import uniqBy from 'lodash-es/uniqBy';
import values from 'lodash-es/values';

// just add here the lodash functions you want to support
const chainableFunctions = {
	// Array methods
	map,
	filter,
	flatMap,
	flatten,
	compact,
	uniq,
	uniqBy,
	reverse,
	chunk,
	take,
	takeWhile,
	partition,
	// Sorting & ordering
	sortBy,
	orderBy,
	// Collection methods
	groupBy,
	keyBy,
	countBy,
	find,
	reduce,
	some,
	every,
	size,
	// Set operations
	difference,
	intersection,
	union,
	// Aggregation
	maxBy,
	minBy,
	sumBy,
	// Object methods
	mapValues,
	values,
	toPairs,
	pick,
	omit,
};

export const lodashChain = <T>(input: T[]) => {
	let value = input;
	const wrapper = {
		...mapValues(chainableFunctions, (f: any) => (...args: any[]) => {
			// lodash always puts input as the first argument
			value = f(value, ...args);
			return wrapper;
		}),
		value: () => value,
	};
	return wrapper as unknown as CollectionChain<T>;
};
